import { useTranslation } from 'react-i18next';
import { Col, Item, RichTextInput, Row, Section, SelectInput, Text, Title } from 'ui';
import { useProgramMentions } from '../../hooks';
import ActivityReminders from './ActivityReminders';
import ActivityTimes from './ActivityTimes';

type P = {
  disabledEdit: boolean;
  programId: string;
};

const schedulingOptions = {
  days: [
    { name: 'Monday', value: 'Monday' },
    { name: 'Tuesday', value: 'Tuesday' },
    { name: 'Wednesday', value: 'Wednesday' },
    { name: 'Thursday', value: 'Thursday' },
    { name: 'Friday', value: 'Friday' },
    { name: 'Saturday', value: 'Saturday' },
    { name: 'Sunday', value: 'Sunday' },
  ],
  periodicity: [
    { name: 'One time', value: 'one_time' },
    { name: 'Daily', value: 'daily' },
    { name: 'Weekly', value: 'weekly' },
    { name: 'Monthly', value: 'monthly' },
    { name: 'Quarterly', value: 'quarterly' },
    { name: 'Annually', value: 'annually' },
  ],
};

const ActivityFormStep4 = ({ disabledEdit, programId }: P) => {
  const handleOnRequestMentions = useProgramMentions(programId);
  const { t } = useTranslation();

  return (
    <div className="activity-form-step-4">
      <Section lineBottom lineTop={false} paddingBottom={false} paddingTop={false}>
        <Title level={3} marginBottom>
          Frequency
        </Title>
        <Row gutter="ms">
          <Col span={12}>
            <SelectInput
              input={{
                disabled: disabledEdit,
                getOptionLabel: (option) => t(option.name),
                getOptionValue: (option) => option.value,
                options: schedulingOptions.periodicity,
                placeholder: t('Please select periodicity'),
              }}
              item={{
                label: 'Frequency',
                name: 'periodicity_type',
                rules: [
                  {
                    required: true,
                  },
                ],
              }}
            />
          </Col>
          <Item
            noStyle
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
            shouldUpdate={(previousValues: any, currentValues: any) =>
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
              previousValues.periodicity_type !== currentValues.periodicity_type
            }
          >
            {({ getFieldValue }) =>
              getFieldValue('periodicity_type') === 'daily' ? (
                <Col span={12}>
                  <ActivityTimes disabled={disabledEdit} name="times" />
                </Col>
              ) : null
            }
          </Item>
        </Row>
      </Section>
      <Section lineBottom lineTop={false} paddingBottom paddingTop>
        <Title level={3} marginBottom>
          Reminders
        </Title>
        <Text className="activity-form__reminders__description">reminderInfo</Text>
        <ActivityReminders disabled={disabledEdit} name="reminders" />
      </Section>
      <Section lineBottom={false} lineTop={false} paddingBottom={false} paddingTop>
        <Title level={3} marginBottom>
          Additional details
        </Title>

        <RichTextInput
          html={{ label: 'Description', mentions: handleOnRequestMentions, name: 'html_description' }}
          text={{ name: 'description' }}
        />
      </Section>
    </div>
  );
};

export default ActivityFormStep4;
